import { useState } from "react";
import ModalQuestionResumeDif from "../modal/modalQuestionResumeDificulty";

function ScrumBoard({ id }) {
  const [modalQuestionResumeDif, setModalQuestionResumeDif] = useState(false);
  const [title, setTitle] = useState("");
  const [textStyle, setTextStyle] = useState("text-danger");
  const [dificultyMode, setDificultyMode] = useState("dificult");
  function handleClickHardest() {
    setTitle("5 Hardest Questions");
    setTextStyle("text-danger");
    setDificultyMode("dificult");
    setModalQuestionResumeDif(true);
  }
  function handleClickEasiest() {
    setTitle("5 Easiest Questions");
    setTextStyle("text-theme");
    setDificultyMode("easy");
    setModalQuestionResumeDif(true);
  }
  return (
    <>
      <div className="list-group list-group-flush">
        <div className="list-group-item d-flex px-3">
          <div className="me-3 pt-1">
            <i className="far fa-question-circle text-inverse text-opacity-50 fa-fw fa-lg"></i>
          </div>
          <div className="flex-fill">
            <div className="fw-400 text-danger">5 Hardest Questions</div>
            <div className="small text-inverse text-opacity-50 mb-2"> Click "show" to find out the 5 most difficult questions</div>
            <div>
              <span onClick={handleClickHardest} className="badge border border-theme btn btn-outline-theme text-theme">
                show
              </span>
            </div>
          </div>
        </div>
        <div className="list-group-item d-flex px-3">
          <div className="me-3 pt-1">
            <i className="far fa-question-circle text-inverse text-opacity-50 fa-fw fa-lg"></i>
          </div>
          <div className="flex-fill">
            <div className="fw-400 text-theme">5 Easiest Questions</div>
            <div className="small text-inverse text-opacity-50 mb-2"> Click "show" to find out the 5 most easiest questions</div>
            <div>
              <span onClick={handleClickEasiest} className="badge border border-theme btn btn-outline-theme text-theme">
                show
              </span>
            </div>
          </div>
        </div>
      </div>
      <ModalQuestionResumeDif diffculty={dificultyMode} textStyle={textStyle} title={title} id={id} show={modalQuestionResumeDif} onHide={() => setModalQuestionResumeDif(false)} />
    </>
  );
}
export default ScrumBoard;
